var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyChooseFiveIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1021 27.9231C25.662 27.9231 29.3585 24.1462 29.3585 19.4872C29.3585 14.8281 25.662 11.0513 21.1021 11.0513C16.5422 11.0513 12.8457 14.8281 12.8457 19.4872C12.8457 24.1462 16.5422 27.9231 21.1021 27.9231Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82031 36.1795C9.0824 33.6955 11.0082 31.6092 13.3843 30.1518C15.7604 28.6945 18.4939 27.9231 21.2819 27.9231C24.0698 27.9231 26.8033 28.6945 29.1794 30.1518C31.5555 31.6092 33.4813 33.6955 34.7434 36.1795",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9263 17.7662C41.6336 21.9689 40.987 26.2877 39.0797 30.0989C37.1724 33.9102 34.1033 37.0166 30.3153 38.9698C26.5274 40.9229 22.2168 41.6217 18.0058 40.9652C13.7948 40.3086 9.90149 38.3308 6.88792 35.3172C3.87435 32.3036 1.89651 28.4103 1.23998 24.1993C0.583451 19.9884 1.28221 15.6777 3.23536 11.8898C5.18851 8.10186 8.29498 5.03268 12.1062 3.12541C15.9174 1.21815 20.2362 0.571492 24.439 1.27882",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9482 6.02569L36.2987 9.25646L42.9995 2.79492",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyChooseFiveIcon2);
export default __webpack_public_path__ + "static/media/why-choose-five-icon-2.06fbec08f291b6577ae383dbe6504a5e.svg";
export { ForwardRef as ReactComponent };